module.exports = __webpack_public_path__ + "img/icon-dots-active.09cf1ad0.svg";